export const mapEpicListToOptions = (list = []) =>
    (list || []).map((item) => ({
        label: item?.title || 'Untitled Epic',
        value: item?._id,
        epicKey: item?.epicKey != null ? String(item.epicKey) : '',
    }))

export const getEpicDisplayOptionFromTask = (task) => {
    const raw = task?.epic
    const record = Array.isArray(raw)
        ? raw[0]
        : raw && typeof raw === 'object' && (raw._id || raw.id)
          ? raw
          : null
    if (!record) return null
    const id = record._id ?? record.id
    if (id == null || id === '') return null
    return {
        label: record?.title || record?.name || 'Untitled Epic',
        value: id,
        epicKey: record?.epicKey != null ? String(record.epicKey) : '',
    }
}
